import { Avatar, styled } from '@mui/material';

import { AvatarProps } from './types';

export const SAvatar = styled(Avatar)<AvatarProps>(({ theme, size, color = 'primary' }) => ({
  width: 48,
  height: 48,

  ...(color === 'primary' && {
    '& .MuiSvgIcon-root': {
      fill: theme.palette.primary[600],
    },

    backgroundColor: theme.palette.primary[100],
  }),
  ...(color === 'primaryDark' && {
    '& .MuiSvgIcon-root': {
      fill: theme.palette.common.white,
    },

    backgroundColor: theme.palette.primary[600],
  }),
  ...(color === 'secondary' && {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[600],
  }),

  ...(color === 'failed' && {
    backgroundColor: theme.palette.error[100],
    color: theme.palette.error[700],
  }),

  ...(color === 'done' && {
    backgroundColor: theme.palette.success[100],
    color: theme.palette.success[700],
  }),

  ...(size === 'xs' && {
    height: 24,
    width: 24,
  }),

  ...(size === 'sm' && {
    height: 32,
    width: 32,
  }),

  ...(size === 'md' && {
    height: 40,
    width: 40,
  }),

  ...(size === 'lg' && {
    height: 48,
    width: 48,
  }),
}));
